// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"85":"component---src-pages-js","423":"2b408618","532":"styles"}[chunkId] || chunkId) + "-" + {"85":"a5ec93df138ebc27cc7d","401":"02d3c686c940a282df39","423":"3678caef8881e838d614","532":"c472a802a06fafc744f1"}[chunkId] + ".js";
};